
import React, { Component } from "react";
import classNames from "classnames";

import { Highlighter, Table, TableBody, TableBodyCell, TableHead, TableHeadCell, TableRow, DivTooltip, Tooltip, TooltipHeader, TooltipBody, Divider, Currency, IconTable } from "@wg/wows-react-uikit";

import map from "lodash/map";
import get from "lodash/get";
import filter from "lodash/filter";
import indexOf from "lodash/indexOf";
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";

import { thousands } from "../../../../../helpers/formatting";
import { t } from "../../../../../helpers/localization";
import { getNationUrl, getShipTypeUrl, getLocalizationShipTypeName, NATIONS_SHIPS_TEXTS_MAP } from "../../../../../helpers/nationsAndShips";

import { CompetitionMetric } from "../../../../../Reducers/ReducerClanWars";

import styles from "./MyWarTable.scss";

const WAR_TABLE_ROW_DATA = [{
  modify: 'middle',
  type: 'nation'
}, {
  modify: 'center',
  type: 'battleship'
}, {
  modify: 'center',
  type: 'cruiser'
}, {
  modify: 'center',
  type: 'destroyer'
}, {
  modify: 'center',
  type: 'aircarrier'
}];

export type Props = {
  unavailableCells: [];
  nations: Array<string>;
  data: [];
  grades: Array<number>;
  topGradesIncrement: number;
  unavailableCells: Array<{
    nation: string;
    class: string;
  }>;
  competitionMetric: CompetitionMetric;

  onCellClick: (nation: string, type: string) => void;
};

class MyWarTable extends Component<Props> {

  renderTableHead() {
    return map(WAR_TABLE_ROW_DATA, (cell, key) => {
      return <TableHeadCell key={`head-cell-${key}`} modify={cell.modify}>
                    <span className={classNames(styles.headerCell, cell.type)}>
                        {cell.type !== 'nation' && <img className={styles.shipTypeIcon} src={getShipTypeUrl(cell.type)} alt="" />}
                        {cell.type !== 'nation' && <span>{getLocalizationShipTypeName(cell.type)}</span>}
                    </span>
                </TableHeadCell>;
    });
  }

  getNationShipTypeGradeInfo(nation: string, type: string) {
    const battlesArray = get(this.props.data, `${nation}.${type}`, []);

    const battlesWithReachedGrade = filter(battlesArray, battle => {
      return battle.isReachedGrade;
    });

    battlesWithReachedGrade.sort((a, b) => {
      return a.claimedGrade - b.claimedGrade;
    });

    let reachedGrade = null;
    let reachedGradeIndex = null;
    let nextGrade = null;

    if (!isEmpty(battlesWithReachedGrade)) {
      reachedGrade = battlesWithReachedGrade[battlesWithReachedGrade.length - 1].claimedGrade;
      reachedGradeIndex = indexOf(this.props.grades, reachedGrade);

      nextGrade = reachedGradeIndex !== -1 && !isUndefined(this.props.grades[reachedGradeIndex + 1]) ? this.props.grades[reachedGradeIndex + 1] : reachedGrade + this.props.topGradesIncrement;

      nextGrade = reachedGradeIndex !== -1 && !isUndefined(this.props.grades[reachedGradeIndex + 1]) ? this.props.grades[reachedGradeIndex + 1] : reachedGrade + this.props.topGradesIncrement;
      return {
        nextGrade,
        reachedGrade,
        reachedGradeBattlesCount: battlesWithReachedGrade.length
      };
    } else {
      return {
        nextGrade: this.props.grades[0],
        reachedGrade: '-',
        reachedGradeBattlesCount: 0
      };
    }
  }

  getActiveBattle = (nation: string, shipClass: string) => {
    const battles = get(this.props.data, `${nation}.${shipClass}`, []);

    return battles.filter(item => {
      return !item.finishedAt && item.startedAt;
    });
  };

  renderTableBody() {
    return this.props.nations.map(nation => {
      return <TableRow key={`war-table-row-${nation}`}>
                    {map(WAR_TABLE_ROW_DATA, (cell, key) => {

          const isDenied = filter(this.props.unavailableCells, { shipNation: nation, shipClass: cell.type }).length;

          // TODO: how to get real nations from gloss?
          const nationData = NATIONS_SHIPS_TEXTS_MAP[nation];

          if (!isDenied) {
            const nationShipTypeGradeInfo = this.getNationShipTypeGradeInfo(nation, cell.type);
            const activeBattles = this.getActiveBattle(nation, cell.type);
            const isInBattle = activeBattles.length > 0;
            const activePlayers = activeBattles.map(item => {
              return item.nick;
            }).join(', ');

            return <TableBodyCell key={`war-table-body-cell-${nation}-${cell.type}`} modify={cell.modify} isHovering={cell.type !== 'nation'} onClick={() => {
              cell.type !== 'nation' && this.props.onCellClick(nation, cell.type);
            }}>
                                        {cell.type !== 'nation' ? <DivTooltip className={styles.cellWrap} tooltipBody={<Tooltip>
                                                                    <TooltipHeader isBold={false} isHelpIcon={false}>
                                                                        <div className={styles.title}>
                                                                            {t('Текущие результаты')}
                                                                        </div>
                                                                    </TooltipHeader>
                                                                    <TooltipBody>
                                                                        <div className={styles.tooltipRaw}>
                                                                            {t('Результат:')}
                                                                            <Currency isBold type="cwars-star" amount={nationShipTypeGradeInfo.reachedGradeBattlesCount} t={t} />
                                                                        </div>
                                                                        {isInBattle ? <div className={styles.tooltipRaw}>
                                                                                {t('Сейчас в бою:')}
                                                                                <span className={styles.activePlayers}>{activePlayers}</span>
                                                                            </div> : null}
                                                                    </TooltipBody>
                                                                    <Divider type="major" />
                                                                    <TooltipBody>
                                                                        <div className={styles.tooltipRaw}>
                                                                            {t('Последняя взятая планка:')}
                                                                            &nbsp;
                                                                            <Currency isBold type={Currency.metricIconName[this.props.competitionMetric]} amount={nationShipTypeGradeInfo.reachedGrade} t={t} />
                                                                        </div>
                                                                        <div className={styles.tooltipRaw}>
                                                                            {t('Следующая планка:')}
                                                                            &nbsp;
                                                                            <Currency isBold type={Currency.metricIconName[this.props.competitionMetric]} amount={nationShipTypeGradeInfo.nextGrade} t={t} />
                                                                        </div>
                                                                    </TooltipBody>
                                                                </Tooltip>}>
                                                        <div className={`${styles.bodyCell} ${styles.bodyCellInline}`}>

                                                            <div className={styles.inlineRelative}>
                                                                {isInBattle ? <div className={styles.activeBattleIcon}>
                                                                        <IconTable glyph={'battles'} />
                                                                    </div> : null}
                                                                <Highlighter value={thousands(nationShipTypeGradeInfo.nextGrade)} />
                                                                <Currency amount={0} type={Currency.metricIconName[this.props.competitionMetric]} onlyIcon t={t} />
                                                            </div>
                                                        </div>

                                                    </DivTooltip> : <DivTooltip className={classNames(styles.bodyCell, styles.nation)} tooltipBody={<Tooltip>
                                                                    <TooltipBody>
                                                                        {nationData.name}
                                                                    </TooltipBody>
                                                                </Tooltip>}>
                                                        <img src={getNationUrl(nation)} alt="" />
                                                    </DivTooltip>}
                                    </TableBodyCell>;
          } else {
            return <TableBodyCell key={`war-table-body-cell-${nation}-${cell.type}`} modify={cell.modify} isHovering={false} onClick={() => {}}>
                                        <div className={styles.emptyCell} />
                                    </TableBodyCell>;
          }
        })}
                </TableRow>;
    });
  }

  render() {
    return <div className={styles.container}>
                <Table>
                    <TableHead>
                        {this.renderTableHead()}
                    </TableHead>
                    <TableBody>
                        {this.renderTableBody()}
                    </TableBody>
                </Table>
            </div>;
  }
}

export default MyWarTable;